import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  ADD_ZONE,
  DELETE_ZONE,
  GET_ALL_ZONE,
  GET_ALL_ZONE_LIST,
  GET_ZONE_DETAILS,
  UPDATE_ZONE_DETAILS,
  UPDATE_ZONE_STATUS,
} from "helpers/url_helper"

export const getAllZoneList = createAsyncThunk(GET_ALL_ZONE_LIST, async () => {
  const response = await get(GET_ALL_ZONE_LIST)
  return response
})

export const getAllZones = createAsyncThunk(GET_ALL_ZONE, async payload => {
  const response = await post(GET_ALL_ZONE, payload)
  return response
})

export const updateZoneStatus = createAsyncThunk(
  UPDATE_ZONE_STATUS,
  async payload => {
    const response = await patch(UPDATE_ZONE_STATUS, payload)
    return response
  }
)

export const addZone = createAsyncThunk(ADD_ZONE, async payload => {
  const response = await post(ADD_ZONE, payload)
  return response
})

export const getZoneDetails = createAsyncThunk(
  GET_ZONE_DETAILS,
  async payload => {
    const response = await post(GET_ZONE_DETAILS, payload)
    return response
  }
)

export const updateZone = createAsyncThunk(
  UPDATE_ZONE_DETAILS,
  async payload => {
    const response = await put(UPDATE_ZONE_DETAILS, payload)
    return response
  }
)

export const deleteZone = createAsyncThunk(DELETE_ZONE, async payload => {
  const response = await del(`${DELETE_ZONE}/${payload.id}`)
  return response
})
